import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";

/**
 * Toggles between light and dark mode.
 *
 * When a custom palette is active (inline CSS vars on <html>),
 * those inline styles override the .dark CSS rules.
 * So we must clear them before toggling, then let globals.css handle it.
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const handleToggle = () => {
    // 1. Clear ALL inline CSS variables so .dark class rules take effect
    const root = document.documentElement;
    const inlineProps: string[] = [];
    for (let i = 0; i < root.style.length; i++) {
      const prop = root.style[i];
      if (prop.startsWith("--")) {
        inlineProps.push(prop);
      }
    }
    inlineProps.forEach((prop) => root.style.removeProperty(prop));

    // 2. Clear saved palette so ThemeLoader doesn't re-apply on next render
    localStorage.removeItem("seweb-active-theme-id");

    // 3. Toggle dark/light via next-themes
    document.documentElement.classList.add("theme-transition");
    setTheme(theme === "dark" ? "light" : "dark");
    setTimeout(() => {
      document.documentElement.classList.remove("theme-transition");
    }, 350);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9 rounded-full"
      onClick={handleToggle}
      title={theme === "dark" ? "Modo claro" : "Modo escuro"}
    >
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-transform dark:rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-transform dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Alternar tema</span>
    </Button>
  );
}
